import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  wrapper: {
    padding: 20,
    backgroundColor: white,
    width: '100%',
  },
});
